import { ApiAccountDashboardModelPortfolio } from 'api/rtk-api'
import { ValueSunburstWithTable } from 'components/core-v2'

import classes from './index.module.scss'

interface Props {
  portfolios: ApiAccountDashboardModelPortfolio[]
}
export const RebalancingTab = ({ portfolios }: Props) => {
  const series = portfolios.reduce(
    (acc, portfolio) => {
      const type = acc.find(type => type.name === portfolio.rebalancingDefinition.type)
      type.count += portfolio?.numberOfActiveAccounts || 0
      type.value += portfolio?.zarValue || 0

      return acc
    },
    [
      { name: 'None', count: 0, value: 0, parent: '0', id: 'none' },
      { name: 'Weight', count: 0, value: 0, parent: '0', id: 'weight' },
      { name: 'Frequency', count: 0, value: 0, parent: '0', id: 'frequency' }
    ]
  )

  return (
    <ValueSunburstWithTable
      allowTooltipOutside={false}
      className={classes.sunburstWrapper}
      data={series}
      seriesName="Rebalancing"
      tableWidth="100%"
    />
  )
}
